import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalWhatIsPpComponent } from './modal-what-is-pp.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalWhatIsPpComponent],
  providers: [],
})
export class ModalWhatIsPpModule {}
